import { render, staticRenderFns } from "./DictSelectTag.vue?vue&type=template&id=73ae09be&scoped=true&"
import script from "./DictSelectTag.vue?vue&type=script&lang=js&"
export * from "./DictSelectTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ae09be",
  null
  
)

export default component.exports